<template>
  <div class="comp-sub-form-inner">
    <!-- 测试内容{{renderRowItem}} -->
    <!--数字 单行文本 多行文本 百分比 金额 自增编码 计算类型-->
    <template v-if="textNumberList.includes(getFieldsInfo(slotName)?.fieldType)">
      <template v-if="hasChange">
        <div class="content-box" v-if="renderRowItem?.oldValue || renderRowItem?.oldValue == 0">
          <jw-tooltip :content="formattedValue(slotName, 'old')">
            <jw-tag class="val-box old-val">
              {{ formattedValue(slotName, 'old') }}
            </jw-tag>
          </jw-tooltip>
        </div>

        <div class="content-box" v-if="renderRowItem?.newValue || renderRowItem?.newValue == 0">
          <jw-tooltip :content="formattedValue(slotName, 'new')">
            <jw-tag class="val-box new-val">
              {{ formattedValue(slotName, 'new') }}
            </jw-tag>
          </jw-tooltip>
        </div>
      </template>
      <template v-else>
        <span class="no-change-text">字段无修改</span>
      </template>
    </template>

    <!-- 日期范围 -->
    <template v-else-if="dateTxtList.includes(getFieldsInfo(slotName)?.fieldType)">
      <template v-if="hasChange">
        <div class="content-box" v-if="formattedValue(slotName, 'old')">
          <jw-tooltip :content="formattedValue(item, 'old')">
            <jw-tag class="val-box old-val">
              {{ formattedValue(slotName, 'old') }}
            </jw-tag>
          </jw-tooltip>
        </div>

        <div class="content-box" v-if="formattedValue(slotName, 'new')">
          <jw-tooltip :content="formattedValue(slotName, 'new')">
            <jw-tag class="val-box new-val">
              {{ formattedValue(slotName, 'new') }}
            </jw-tag>
          </jw-tooltip>
        </div>
      </template>

      <template v-else><span class="no-change-text">字段无修改</span></template>
    </template>

    <!--单选、多选、下拉单选、下拉多选-->
    <template v-else-if="selectList.includes(getFieldsInfo(slotName)?.fieldType)">
      <template v-if="hasChange">
        <div class="content-box" v-if="renderRowItem?.oldValue">
          <div v-if="[3, 5].includes(getFieldsInfo(slotName)?.fieldType)" class="muti-box">
            <template v-for="(vItem, index) in formattedValue(slotName, 'old')" :key="index">
              <jw-tooltip :content="vItem">
                <jw-tag class="val-box old-val">
                  {{ vItem }}
                </jw-tag>
              </jw-tooltip>
            </template>
          </div>
          <template v-else>
            <jw-tooltip :content="formattedValue(slotName, 'old')">
              <jw-tag class="val-box old-val">
                {{ formattedValue(slotName, 'old') }}
              </jw-tag>
            </jw-tooltip>
          </template>
        </div>

        <div class="content-box" v-if="renderRowItem?.newValue">
          <div class="muti-box" v-if="[3, 5].includes(getFieldsInfo(slotName)?.fieldType)">
            <template v-for="(vItem, index) in formattedValue(slotName, 'new')" :key="index">
              <jw-tooltip :content="vItem">
                <jw-tag class="val-box new-val">
                  {{ vItem }}
                </jw-tag>
              </jw-tooltip>
            </template>
          </div>
          <template v-else>
            <jw-tooltip :content="formattedValue(slotName, 'new')">
              <jw-tag class="val-box new-val">
                {{ formattedValue(slotName, 'new') }}
              </jw-tag>
            </jw-tooltip>
          </template>
        </div>
      </template>
      <template v-else><span class="no-change-text">字段无修改</span></template>
    </template>

    <!-- 人员 & 部门 -->
    <template v-else-if="personList.includes(getFieldsInfo(slotName)?.fieldType)">
      <template v-if="hasChange">
        <div class="content-box" v-if="renderRowItem?.oldValue">
          <div class="muti-box">
            <template v-for="(vItem, index) in formattedValue(slotName, 'old')" :key="index">
              <jw-tooltip :content="vItem">
                <jw-tag class="val-box old-val">
                  {{ vItem }}
                </jw-tag>
              </jw-tooltip>
            </template>
          </div>
        </div>
        <div class="content-box" v-if="renderRowItem?.newValue">
          <div class="muti-box">
            <template v-for="(vItem, index) in formattedValue(slotName, 'new')" :key="index">
              <jw-tooltip :content="vItem">
                <jw-tag class="val-box new-val">
                  {{ vItem }}
                </jw-tag>
              </jw-tooltip>
            </template>
          </div>
        </div>
      </template>
      <template v-else><span class="no-change-text">字段无修改</span></template>
    </template>

    <!-- 附件 -->
    <template v-else-if="fileList.includes(getFieldsInfo(slotName)?.fieldType)">
      <template v-if="hasChange">
        <div class="content-box" v-if="renderRowItem?.oldValue">
          <div class="muti-box">
            <template v-for="(vItem, index) in formattedValue(slotName, 'old')" :key="index">
              <jw-tooltip :content="vItem">
                <template #content>
                  <p>附件名称：{{ vItem.name }}</p>
                  <p>附件格式：{{ vItem.name.split('.').pop() }}</p>
                </template>
                <jw-tag class="val-box old-val">
                  {{ vItem.name }}
                </jw-tag>
              </jw-tooltip>
            </template>
          </div>
        </div>
        <div class="content-box" v-if="renderRowItem?.newValue">
          <div class="muti-box">
            <template v-for="(vItem, index) in formattedValue(slotName, 'new')" :key="index">
              <jw-tooltip :content="vItem.url">
                <template #content>
                  <p>附件名称：{{ vItem.name }}</p>
                  <p>附件格式：{{ vItem.name.split('.').pop() }}</p>
                </template>
                <jw-tag class="val-box new-val">
                  {{ vItem.name }}
                </jw-tag>
              </jw-tooltip>
            </template>
          </div>
        </div>
      </template>
      <template v-else><span class="no-change-text">字段无修改</span></template>
    </template>

    <!-- 查找关联 -->
    <template v-else-if="findList.includes(getFieldsInfo(slotName)?.fieldType)">
      <template v-if="hasChange">
        <div class="content-box" v-if="renderRowItem?.oldValue">
          <div class="muti-box">
            <template v-for="(vItem, index) in formattedValue(slotName, 'old')" :key="index">
              <jw-tooltip :content="vItem">
                <jw-tag class="val-box old-val">
                  {{ vItem }}
                </jw-tag>
              </jw-tooltip>
            </template>
          </div>
        </div>
        <div class="content-box" v-if="renderRowItem?.newValue">
          <div class="muti-box">
            <template v-for="(vItem, index) in formattedValue(slotName, 'new')" :key="index">
              <jw-tooltip :content="vItem">
                <jw-tag class="val-box new-val">
                  {{ vItem }}
                </jw-tag>
              </jw-tooltip>
            </template>
          </div>
        </div>
      </template>
      <template v-else><span class="no-change-text">字段无修改</span></template>
    </template>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue';
import { handleShowValue, textNumberList, selectList, dateTxtList, personList, fileList, findList, richTxtList } from '@/utils/operation-log';
console.log('1-开始创建组件-setup', selectList, dateTxtList, personList, fileList, findList, richTxtList);

const props = defineProps({
  slotName: {
    type: String // 字段fieldKey
  },
  row: {
    type: Object // 行数据
  },
  allFields: {
    type: Array // 对象下所有字段信息
  }
});

// const subFormAllFields = computed(() => {
//   return props.allFields.filter((fItem) => fItem.fieldType === 27)
// })

console.log('组件入参', props);

// 根据字段key获取字段信息
const getFieldsInfo = (fieldKey) => {
  if (!fieldKey) return null;
  const result = props.allFields.find((item) => item.fieldKey === fieldKey);
  return result;
};

const formattedValue = (filedItem, type) => {
  const fieldInfo = getFieldsInfo(filedItem); // 获取字段信息
  const handleValue = type === 'new' ? renderRowItem.value?.newValue : renderRowItem.value?.oldValue;
  return handleShowValue(fieldInfo, handleValue);
};

const renderRowItem = computed(() => {
  return props.row[props.slotName];
});

const hasChange = computed(() => {
  const { oldValue, newValue } = renderRowItem.value || {};
  return oldValue !== undefined || newValue !== undefined;
});

const data = reactive({});
const name = ref();
console.log(data, name, props);
</script>
<style scoped lang="less">
@import './sub-form-inner.less';
</style>
